export const SIDEBAR = 'sidebar';
export const FILTERS = 'filters';
export const TAGS = 'tags';
export const CUSTOMIZE_COLUMNS = 'customizeColumns';
